import { Input_Template_Switch, Output_Template_Finish } from '..';
import { ModuleIOValueTypeEnum, ModuleTemplateTypeEnum } from '../../constants';
import { FlowNodeInputTypeEnum, FlowNodeTypeEnum } from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';

export const OutputTextModule: FlowModuleTemplateType = {
  id: 'outputText',
  templateType: ModuleTemplateTypeEnum.output,
  flowType: FlowNodeTypeEnum.messageOutput,
  name: '消息输出',
  description: '发送消息到回调地址',
  inputs: [
    Input_Template_Switch,
    {
      label: 'chatId',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.hidden,
      key: 'chatId',
      required: true,
      value: '{chatId}',
    },
    {
      label: '回调地址',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.select,
      key: 'outputUrl',
      required: true,
      list: [
        { label: '企微侧边栏', value: 'xxxx' },
        { label: '用户消息', value: 'xxxx' },
      ],
    },
    {
      label: '消息',
      valueType: ModuleIOValueTypeEnum.any,
      type: FlowNodeInputTypeEnum.textarea,
      key: 'messageOutput',
      showTargetInApp: true,
      showTargetInPlugin: true,
    },
  ],
  outputs: [Output_Template_Finish],
};
